const AWS_SIGNED_URL_PARAMS = [
  'X-Amz-Algorithm',
  'X-Amz-Credential',
  'X-Amz-Signature',
];

const isAwsSignedUrl = (url: URL): boolean =>
  AWS_SIGNED_URL_PARAMS.every(param => url.searchParams.has(param));

export default isAwsSignedUrl;
